import type { RegistryEntry } from '../types';

const OUTPUT_FORMAT_OPTIONS = [
  { label: 'JPEG', value: 'jpeg' },
  { label: 'JPG', value: 'jpg' },
  { label: 'PNG', value: 'png' },
  { label: 'TIFF', value: 'tiff' },
  { label: 'TIF', value: 'tif' },
] as const;

const DENOISE_OUTPUT_FORMAT_OPTIONS = [
  { label: 'JPEG', value: 'jpeg' },
  { label: 'JPG', value: 'jpg' },
  { label: 'PNG', value: 'png' },
] as const;

const toTopazProviderOptions = (ui: Record<string, any>, defaultModel: string) =>
  ({
    model: typeof ui.model === 'string' ? ui.model : defaultModel,
    output_format: typeof ui.output_format === 'string' ? ui.output_format : 'jpeg',
  }) as unknown as Record<string, Record<string, any>>;

export const topazConfigs: Record<string, RegistryEntry> = {
  'topaz/image/sharpen': {
    options: [
      {
        key: 'model',
        label: 'Model',
        type: 'select',
        options: [
          { label: 'Standard', value: 'Standard' },
          { label: 'Strong', value: 'Strong' },
          { label: 'Lens Blur', value: 'Lens Blur' },
          { label: 'Lens Blur V2', value: 'Lens Blur V2' },
          { label: 'Motion Blur', value: 'Motion Blur' },
          { label: 'Natural', value: 'Natural' },
          { label: 'Refocus', value: 'Refocus' },
          { label: 'Wildlife', value: 'Wildlife' },
          { label: 'Portrait', value: 'Portrait' },
        ],
        default: 'Standard',
        group: 'inline',
      },
      {
        key: 'output_format',
        label: 'Output Format',
        type: 'select',
        options: [...OUTPUT_FORMAT_OPTIONS],
        default: 'jpeg',
        group: 'basic',
      },
    ],
    toProviderOptions: (ui) => toTopazProviderOptions(ui, 'Standard'),
  },
  'topaz/image/restore': {
    options: [
      {
        key: 'model',
        label: 'Model',
        type: 'select',
        options: [
          { label: 'Dust-Scratch', value: 'Dust-Scratch' },
          { label: 'Dust-Scratch V2', value: 'Dust-Scratch V2' },
        ],
        default: 'Dust-Scratch',
        group: 'inline',
      },
      {
        key: 'output_format',
        label: 'Output Format',
        type: 'select',
        options: [...OUTPUT_FORMAT_OPTIONS],
        default: 'jpeg',
        group: 'basic',
      },
    ],
    toProviderOptions: (ui) => toTopazProviderOptions(ui, 'Dust-Scratch'),
  },
  'topaz/image/lighting': {
    options: [
      {
        key: 'model',
        label: 'Model',
        type: 'select',
        options: [
          { label: 'Adjust', value: 'Adjust' },
          { label: 'Adjust V2', value: 'Adjust V2' },
          { label: 'White Balance', value: 'White Balance' },
          { label: 'Colorize', value: 'Colorize' },
        ],
        default: 'Adjust',
        group: 'inline',
      },
      {
        key: 'output_format',
        label: 'Output Format',
        type: 'select',
        options: [...OUTPUT_FORMAT_OPTIONS],
        default: 'jpeg',
        group: 'basic',
      },
    ],
    toProviderOptions: (ui) => toTopazProviderOptions(ui, 'Adjust'),
  },
  'topaz/image/denoise': {
    options: [
      {
        key: 'model',
        label: 'Model',
        type: 'select',
        options: [
          { label: 'Normal', value: 'Normal' },
          { label: 'Strong', value: 'Strong' },
          { label: 'Extreme', value: 'Extreme' },
        ],
        default: 'Normal',
        group: 'inline',
      },
      {
        key: 'output_format',
        label: 'Output Format',
        type: 'select',
        options: [...DENOISE_OUTPUT_FORMAT_OPTIONS],
        default: 'jpeg',
        group: 'basic',
      },
    ],
    toProviderOptions: (ui) => toTopazProviderOptions(ui, 'Normal'),
  },
};